import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Search } from 'lucide-react';
import { CommonLabel } from '@/components/ui/common-label';
import { useTheme } from '@/hooks/useTheme';

export function NotFound() {
  const { theme } = useTheme();
  
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background text-foreground p-4">
      <div className="flex flex-col items-center justify-center max-w-md w-full text-center">
        <div className="mb-6">
          <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
            <Search className="w-12 h-12 text-primary" />
          </div>
          <CommonLabel size="xxl" weight="bold" className="text-foreground block mb-2">
            404
          </CommonLabel>
          <CommonLabel size="lg" weight="medium" className="text-muted-foreground block mb-4">
            Page Not Found
          </CommonLabel>
          <CommonLabel size="sm" className="text-muted-foreground block">
            Sorry, we couldn't find the page you're looking for. It might have been removed, renamed, or didn't exist in the first place.
          </CommonLabel>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 w-full max-w-xs">
          <Button asChild className="w-full">
            <Link to="/" className="flex items-center justify-center gap-2">
          
              Back to Dashboard
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}